import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

function fmtDT(v){
    try { return new Intl.DateTimeFormat('pl-PL', { dateStyle:'medium', timeStyle:'short' }).format(new Date(v)); }
    catch { return v || '—'; }
}

export default function TermsUp(){
    const nav = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [items, setItems] = useState([]);

    async function load(){
        setErr('');
        try{
            const r = await fetch('/api/prowadzacy/terms/upcoming', { credentials:'include', headers: { ...authHeader() }});
            if (!r.ok) throw new Error((await r.json().catch(()=>({})))?.blad || `Błąd (${r.status})`);
            const j = await r.json();
            setItems(Array.isArray(j) ? j : []);
        }catch(e){ setErr(e.message || 'Błąd pobierania'); }
        finally{ setLoading(false); }
    }

    useEffect(()=>{ load(); }, []);

    return (
        <div style={{ padding:16, marginTop:50 }}>
            <h1 style={{ marginBottom:16 }}>Nadchodzące terminy</h1>

            {loading ? <div>Ładowanie…</div> :
                err ? <div style={{ color:'crimson' }}>{err}</div> :
                    items.length === 0 ? (
                        <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:20, color:'#6b7280' }}>
                            Brak zaplanowanych terminów.
                        </div>
                    ) : (
                        <div style={{ display:'grid', gap:12, maxWidth:1000 }}>
                            {items.map(t => <TermCard key={t.term_id} t={t} onOpen={(id, mode)=>nav(mode==='run'?`/prowadzacy/termin/${id}/przebieg`:`/prowadzacy/termin/${id}`)} />)}
                        </div>
                    )}
        </div>
    );
}

function TermCard({ t, onOpen }){
    const start = new Date(t.exam_datetime);
    const now = new Date();
    const diffMin = (start.getTime() - now.getTime()) / 60000;
    const canRun = diffMin <= 15; // 15 min przed startem

    return (
        <div style={{
            border:'1px solid #e5e7eb', borderRadius:12, padding:14, background:'#fff',
            display:'flex', justifyContent:'space-between', alignItems:'center'
        }}>
            <div>
                <div style={{ fontWeight:600 }}>{t.title || 'Egzamin'}</div>
                <div style={{ color:'#6b7280', fontSize:14 }}>
                    {t.group_name || '—'} • {fmtDT(t.exam_datetime)} • {t.exam_duration} min
                    {t.proctoring ? <span style={{ marginLeft:8, padding:'2px 6px', borderRadius:6, background:'#eef2ff', fontSize:12 }}>Proctoring</span> : null}
                </div>
            </div>
            <div>

                <button
                    className="but-smal"
                    onClick={()=>onOpen(t.term_id, canRun ? 'run' : 'details')}

                >
                    {canRun ? 'Przebieg' : 'Szczegóły'}
                </button>
            </div>
        </div>
    );
}
